import cooperationIcon1 from "@/assets/images/education/cooperation-icon1.png"
import cooperationIcon2 from "@/assets/images/education/cooperation-icon2.png"
import cooperationIcon3 from "@/assets/images/education/cooperation-icon3.png"
import { FAMOUS_ENTERPRISES_LINK } from "@/constants/join-us"

export const EDUCATION_LOGO_WALL = {
  title: "名企直推，人才优聘",
  subtitle:
    "绿色通道，直达面试官；多职位备选，提高就业成功率；TiDB 生态企业高薪职位等你来挑战",
  joinButton: {
    label: "加入 PingCAP",
    value: "/join-us",
  },
  searchButton: {
    label: "名企直推",
    value: FAMOUS_ENTERPRISES_LINK,
  },
}

export const EnterpriseCooperationResource = [
  {
    logo: cooperationIcon1,
    title: "校园人才生态",
    description:
      "致力于整合国内外高校资源，深化产学研融合，赋能未来数据智能人才培养",
    link: "/education-campus",
  },
  {
    logo: cooperationIcon2,
    title: "科研合作",
    description: "通过专项技术合作与国内 10 余所高校建立深入的科研合作关系 ",
    link: "/education-science",
  },
  {
    logo: cooperationIcon3,
    title: "Talent Plan",
    description: "面向开源爱好者、分布式数据库爱好者的一站式学习与实训平台",
    link: "https://tidb.net/talent-plan"
  }
]

export const EDUCATION_ROLE_BTN = {
  beginner: [
    {
      title: "开始线上学习",
      link: "/courses-catalog",
    },
    {
      title: "培训咨询",
      contactForm: true,
    },
    {
      title: "下载培训手册",
      link: "https://www-website-strapi.oss-cn-shanghai.aliyuncs.com/prod/Ping_CAP_2023_3_30_4d22d9663d.pdf",
    },
  ],
  competitiveness: [
    //{
    //  title: "了解课程",
    //  link: "https://learn.pingcap.com/learner/course",
    //},
    {
      title: "立即认证",
      link: "https://learn.pingcap.com/learner/certification-center",
    },
    {
      title: "下载认证手册",
      link: "https://www-website-strapi.oss-cn-shanghai.aliyuncs.com/prod/Ping_CAP_2023_3_30_4d22d9663d.pdf",
    },
  ],
  share: [
    {
      title: "成为认证讲师",
      link: "/certified-instructor",
    },
    {
      title: "加入社区",
      link: "https://tidb.net",
    },
  ],
  cooperation: [
    {
      title: "加入合作伙伴",
      link: '/education-partner',
    },
  ],
}

export const WhyPingCapEducation = [
  {
    icon: "class",
    title: "完备的课程及认证体系",
    description:
      "TiDB 技术专家设计并讲授，提供全球统一标准化的 TiDB 产品能力认证服务。",
  },
  {
    icon: "thumb-up",
    title: "专业的培训服务",
    description: "提供 TiDB 定制化课程内容开发和交付服务",
  },
  {
    icon: "work",
    title: "丰富的就业机会",
    description: "TiDB 生态企业高薪就业直推",
  },
]

export const EDUCATION_COMMUNITY_RESOURCES = {
  name: "更多资源",
  data: [
    {
      iconName: "class",
      title: "在线课程",
      url: "https://learn.pingcap.com/learner/course",
      isBlank: true,
    },
    {
      iconName: "forum",
      title: "TiDB 社区",
      url: "https://tidb.net/",
      isBlank: true,
    },
    {
      iconName: "article",
      title: "TiDB 文档",
      url: "https://docs.pingcap.com/zh/tidb/stable",
      isBlank: true,
    },
    {
      iconName: "verified-user",
      title: "认证核实",
      url: "https://learn.pingcap.com/learner/certificate-check",
      isBlank: true,
      //isClosed: true,
    },
  ],
}
